import React from 'react';

import { Text } from '@prenuvo/shared-library';
import { formatPhoneNumber } from 'packages/formatters';

import { User } from '../../types';
import { Row, Column, Label } from '../Layout';
import { UNITED_KINGDOM } from '../../../../helpers/constants';

interface ContactInformationProps {
  contact: User;
}

const ContactInformation: React.FC<ContactInformationProps> = ({
  contact
}: ContactInformationProps) => (
  <div>
    <Row>
      <Column>
        <Label>Personal Email Address</Label>
        <Text>{contact.email}</Text>
      </Column>
      <Column>
        <Label>Phone Number</Label>
        <Text>{contact.phoneNumber ? formatPhoneNumber(contact.phoneNumber) : 'N/A'}</Text>
      </Column>
    </Row>
    <Row>
      <Column>
        <Label>Address</Label>
        <Text>{contact.address}</Text>
      </Column>
      <Column>
        <Label>City</Label>
        <Text>{contact.city}</Text>
      </Column>
      <Column>
        <Label>Zip / Postal Code</Label>
        <Text>{contact.postalCode}</Text>
      </Column>
    </Row>
    <Row>
      <Column>
        <Label>Country</Label>
        <Text>
          {contact.country === UNITED_KINGDOM.COUNTRY_CODE ? UNITED_KINGDOM.LABEL : contact.country}
        </Text>
      </Column>
      <Column>
        <Label>State / Province</Label>
        <Text>{contact.state}</Text>
      </Column>
    </Row>
  </div>
);

export default ContactInformation;
